import { CheckCircleFilled, CheckCircleOutlined, CheckOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { Button, Popconfirm, message } from "antd"
import { useDispatch } from "react-redux"
import { useEffect, useState } from "react";

import { useDeleteQuizMutation } from "../../../features/quizzes/quizzesApi";
import { editQuiz, toggleModal } from "../../../features/quizzes/quizzesSlice";
import { useEditAssignmentMarkMutation } from "../../../features/assignmentMarks/assignmentMarksApi";

export default function MarksTableRow({ assignment }) {
  const [markValue, setMarkValue] = useState()
  const dispatch = useDispatch();
  const {
    id,
    student_id,
    student_name,
    assignment_id,
    title,
    createdAt,
    totalMark,
    mark,
    repo_link,
    status,
  } = assignment || {}

  const [updateMark, { isLoading, isError, error }] = useEditAssignmentMarkMutation()


  useEffect(() => {
    if (isError) {
      const msg = typeof error?.data == 'string' ? error?.data : 'Internal server error'
      message.error(msg)
    }
  }, [error, isError])

  useEffect(() => {
    if (assignment?.totalMark) {
      setMarkValue(assignment?.totalMark)
    }
  }, [assignment])

  const publishMark = () => {
    if (markValue > totalMark) {
      message.error('Mark cannot be greater than Total mark')
      return;
    }
    const data = { mark: markValue, status: 'published' }
    updateMark({ data, id })
  }
  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">{new Date(createdAt).toLocaleString()}</td>
      <td className="table-td">{student_name}</td>
      <td className="table-td">{repo_link || ''}</td>
      <td className="table-td input-mark">
        {
          status == 'published' ?
            <span>{mark}</span>
            :
            <>
              <input type="number" onChange={e => setMarkValue(e.target.value)} max={totalMark} value={markValue} />
              <span onClick={publishMark}>
                <svg fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                  className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              </span>
            </>
        }
      </td>
    </tr>

  )
}